import { Component, DestroyRef, inject, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurationsService } from 'src/app/services/api/configurations.service';
import { InstancesService } from 'src/app/services/api/instances.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { combineLatest, Subscription } from 'rxjs';
import { DeploymentClass } from 'src/app/models/instance-class';
import { Configuration } from 'src/app/models/configurations/configuration';
import { TestTypes } from 'src/app/models/instance/test-types';
import { translate } from '@jsverse/transloco';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { ConfigurationApplicationStatus, ConfigurationState } from 'src/app/models/configurations/configuration-state';
import cloneDeep from 'lodash/cloneDeep';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { Constants } from 'src/app/models/constants';
import { Instance } from 'src/app/models/instance/instance';
import { SortDirection } from 'src/app/models/sort';
import { KeyValueMap } from 'src/app/models/key-value-map';
import { isDate } from 'src/app/services/util/utils';
import { MatDialog } from '@angular/material/dialog';
import { FeatureKeys } from 'src/app/models/feature/feature-keys';
import { Feature, FeatureAttributes, FeatureDatazone } from 'src/app/models/feature/feature';
import { FeaturePermissionsService } from 'src/app/services/util/feature-permissions.service';
import { ConfigurationDetailsComponent } from 'src/app/components/configuration-details/configuration-details.component';
import { CRVTService } from 'src/app/services/api/crvt.service';
import { UrlService } from 'src/app/services/util/url.service';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { Permission } from 'src/app/models/principal/permission';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { DataZone } from 'src/app/models/data-zone/data-zone';
import { Attributes, Datazone } from 'src/app/models/principal/permission';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { Permissions } from 'src/app/models/principal/permission';
import { EnvironmentPaginatorComponent } from '../environment-paginator/environment-paginator.component';
import { EnvironmentTableComponent } from '../environment-table/environment-table.component';
type ComparatorFunc = (first: any, second: any) => number;
import { toUtcString } from 'src/app/services/util/utils';

const REQUIRED_FEATURES = [
  {
    key: FeatureKeys.RVT_TEST_NONPII,
    name: Feature.RVT_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.NONPII
  },
  {
    key: FeatureKeys.RVT_TEST_PII,
    name: Feature.RVT_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.PII
  }
];

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.INSTANCE_TEST_DATAZONE_NONPII,
    action: Permissions.INSTANCE_TEST,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_TEST_DATAZONE_PII,
    action: Permissions.INSTANCE_TEST,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_TEST_DATAZONE_LIVE,
    action: Permissions.INSTANCE_TEST,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
];

@Component({
  selector: 'app-environment-product-rvt',
  templateUrl: './environment-product-rvt.html',
  styleUrl: './environment-product-rvt.scss',
  standalone: false
})
export class EnvironmentProductRvt {
 @ViewChild(EnvironmentPaginatorComponent)paginatorRef: EnvironmentPaginatorComponent;
  @ViewChild(EnvironmentTableComponent) tableRef: EnvironmentTableComponent;
  @Input() data: any;
  @Input() solution: any;
  @Input() solutionVersion: any;
  @Input() getBlueprints: any;
  private destroyRef = inject(DestroyRef);
  configurations: Configuration[];
  loadDataSubscription: Subscription;
  availableConfigLoaded = false;
   allRvtStates: any;
  selectedRvtFilter = {
    label: 'All',
    value: ''
  };
  rvtStates: any;
  filteredRvtStates: any;
  rvtSearchTerm: any;
  pageRvtStates: any;
  rvtSort: any;
  selectedRvtTab = 0;
  configurationsForRvt: any;
  executeRvtInProgress = false;
  rvtResultsLoaded = false;
  appliedRvtState: any;
  rvtPaginatioSize = 5;
  rvtPageIndex = 0;
  configurationLoaded = false;
  ConfigurationApplicationStatus = ConfigurationApplicationStatus;
  instance: Instance;
  configurationsMap: KeyValueMap<string, Configuration>;
  FeatureKeys = FeatureKeys;
  featuresMap: { [key: string]: boolean };
  DeploymentClass = DeploymentClass;
  filterOptions: any = [
    {
      label: 'All',
      value: ''
    },
    {
      label: 'Success',
      value: ['success']
    },
    {
      label: 'Failed',
      value: ['test_failed', 'configure_failed', 'failed']
    }
  ];
  Constants = Constants;
  displayExecuteRvtColumns = [
  {
    key: 'releasePackageName',
    name: 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.RELEASE_PACKAGE_NAME',
    type: 'text',
    sortable: true,
    visible: true
  },
  {
    key: 'version',
    name: 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.VERSION',
    type: 'text',
    sortable: true,
    visible: true
  },
  {
    key: 'dateGenerated',
    name: 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.DATE_GENERATED',
    type: 'date',
    sortable: true,
    visible: true
  },
  {
    key: 'execute',
    name: '',
    type: 'button',
    sortable: false,
    visible: true
  }
];

  displayViewResultsColumns = [
  {
    key: 'releasePackageName',
    name: 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.RELEASE_PACKAGE_NAME',
    type: 'text',
    sortable: true,
    visible: true,
    keyLink: 'navigation'
  },
  {
    key: 'version',
    name: 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.VERSION',
    type: 'text',
    sortable: true,
    visible: true
  },
  {
    key: 'applicationStartTime',
    name: 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.START_TIME_UTC',
    type: 'date',
    sortable: true,
    visible: true
  },
  {
    key: 'applicationFinishTime',
    name: 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.END_TIME_UTC',
    type: 'date',
    sortable: true,
    visible: true
  },
  {
    key: 'duration',
    name: 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.DURATION',
    type: 'text',
    sortable: true,
    visible: true
  },
  {
    key: 'status',
    name: 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.STATUS',
    type: 'status',
    sortable: true,
    visible: true,
    statusKey: 'status'
  },
  {
    key: 'download',
    name: '',
    type: 'download',
    sortable: false,
    visible: true
  }
];
pageIndex = 0;
paginationSize = 10;
rvtTableData: any;
executeRvtTableData: any;
pageConfigurations: Configuration[];
  filteredConfigurations: Configuration[];
  expandedRows: KeyValueMap<string, boolean> = {};

  selection: Configuration;
  deploymentClass = DeploymentClass;
  Permission = Permission;

  inProgress = false;
  searchValue: string;
  selectedId: any;
  disableSelect = false;
  permissionsMap: { [key: string]: boolean };
  DataZone = DataZone;
  DeployStatus = DeployStatus;
  PermissionKeys = PermissionKeys;
  searchedResult = [];


  constructor(private activatedRoute: ActivatedRoute, private configService: ConfigurationsService,
    private instanceService: InstancesService, private toastrService: CustomToastrService, private dialog: MatDialog,
    private featurePermissionsService: FeaturePermissionsService, private crvtService: CRVTService,
    public urlService: UrlService, private router: Router) {
  }

  ngOnInit(): void {
    this.instance = this.data;
    this.featuresMap = this.featurePermissionsService.resolveFeaturePermissions(REQUIRED_FEATURES);
    this.loadReleaseData(true);
  }

  private loadReleaseData(initialLoad?): void {
    this.configurationLoaded = false;
    const blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    if (this.loadDataSubscription) {
      this.loadDataSubscription.unsubscribe();
      this.loadDataSubscription = null;
    }
    if (!initialLoad) {
      this.getRvtStates();
    }
    if (initialLoad) {
      this.loadDataSubscription = combineLatest([
        this.configService.getConfigurations(blueprintId)
      ])
        .pipe(
        takeUntilDestroyed(this.destroyRef))
        .subscribe(([configurations]) => {
          this.configurations = configurations;
          if (initialLoad) {
            this.getRvtStates();
          }
          this.availableConfigLoaded = true;
        });
    }
  }

  private getRvtStates(): void {
    const instanceId = this.activatedRoute.snapshot.params.instanceId;
    this.instanceService.getTestResults(instanceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(response => {
      if (Number(response?.total) > 10) {
        this.instanceService.getTestResults(instanceId, response?.total)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(result => {
            this.allRvtStates = result.data?.filter(item =>
              item.testType === TestTypes.RVT_TEST
            );
            this.processRvtData();
          })
      } else {
        this.allRvtStates = response.data?.filter(item =>
          item.testType === TestTypes.RVT_TEST
        );
        this.allRvtStates.map(item => item.applicationStart = item.applicationStartTime ? new Date(item.applicationStartTime) : null);
        this.allRvtStates.map(item => item.applicationFinish = item.applicationFinishTime ? new Date(item.applicationFinishTime) : null);
        this.processRvtData();
      }
    },
    (error) => {
      this.configurationLoaded = true;
      this.processRvtData();
        setTimeout(() => {
      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

  processRvtData(): void {
    this.rvtResultsLoaded = true;
    if (this.allRvtStates?.find(config => config.status === ConfigurationApplicationStatus.TESTING)) {
      this.appliedRvtState = this.allRvtStates?.find(config => config.status === ConfigurationApplicationStatus.TESTING);
    }
    if (this.allRvtStates?.find(config => config.id === this.appliedRvtState?.id &&
      config.status === ConfigurationApplicationStatus.SUCCESS)) {
      this.selectedRvtTab = 1;
      this.executeRvtInProgress = false;
      this.loadRvtStates();
    }
    if (this.allRvtStates?.find(config => config.id === this.appliedRvtState?.id &&
      config.status !== ConfigurationApplicationStatus.TESTING && config.status !== ConfigurationApplicationStatus.SUCCESS)) {
      this.executeRvtInProgress = false;
      this.loadRvtStates();
    }
    this.allRvtStates?.sort((state1, state2) => new Date(state2.applicationStartTime).getTime() - new Date(state1.applicationStartTime).getTime());
    const configurations = cloneDeep(this.configurations);
    this.configurationsForRvt = configurations?.filter(config => config?.manifest?.test);
    this.configurationsForRvt?.forEach(config => {
      config.status = this.allRvtStates?.find(item => item.configurationId === config.id)?.status;
    });
    this.loadRvtStates();
    if (!this.instance || !this.allRvtStates) {
      return;
    }
    this.instance.rvtStates = this.allRvtStates;
    if (this.instance.rvtStates?.length > 0) {
      this.instance.latestRvtState = this.instance.rvtStates[0];
    }
    this.configurationLoaded = true;
  }

  private loadRvtStates(): void {
    if (this.selectedRvtFilter.value) {
      this.rvtStates = this.allRvtStates.filter(item => this.selectedRvtFilter.value.includes(item?.status)) || [];
    } else {
      this.rvtStates = this.allRvtStates || [];
    }
    this.configurationsMap = this.configurations?.reduce((acc, configuration) => {
      acc[configuration.id] = configuration;
      return acc;
    }, {});
    this.pageRvtStates = this.rvtStates;
    this.prepareRvtTableData(this.pageRvtStates);
    this.filterRvtRows();
  }

prepareRvtTableData(states: any[]) {
  this.rvtTableData = Array.isArray(states) && states.length
  ? states.map(state => {
      const config = this.configurationsMap?.[state.configurationId];

      return {
        releasePackageName: config?.manifest?.name ?? '-',
        version: config?.manifest?.version ?? '-',
        applicationStartTime: state.applicationStartTime ? toUtcString(state.applicationStartTime) : null,
        applicationFinishTime: state.applicationFinishTime ? toUtcString(state.applicationFinishTime) : null,
        duration: this.calculateDuration(
          state.applicationStartTime,
          state.applicationFinishTime
        ),
        status: state.status ?? '-',
        download: true,
        raw: state
      };
    })
  : [];
  this.rvtTableData = [...this.rvtTableData];
}

private calculateDuration(start: string, end: string): string {
  if (!start || !end) return '-';

  const startTime = new Date(start).getTime();
  const endTime = new Date(end).getTime();

  if (isNaN(startTime) || isNaN(endTime)) return '-';

  const diffMs = endTime - startTime;

  const seconds = Math.floor((diffMs / 1000) % 60);
  const minutes = Math.floor((diffMs / (1000 * 60)) % 60);
  const hours = Math.floor(diffMs / (1000 * 60 * 60));

  if (hours > 0) {
    return `${hours}h ${minutes}m ${seconds}s`;
  }

  if (minutes > 0) {
    return `${minutes}m ${seconds}s`;
  }

  return `${seconds}s`;
}

  doRvtSort(property: string): void {
    if (!this.rvtSort || this.rvtSort.property !== property) {
      this.rvtSort = {
        property,
        direction: SortDirection.ASC
      };
    } else if (this.rvtSort.direction === SortDirection.ASC) {
      this.rvtSort.direction = SortDirection.DESC;
    } else {
      this.rvtSort = null;
    }

    if (!this.rvtSort) {
      this.filteredRvtStates = this.filteredRvtStates.sort(this.propertyComparator('applicationFinishTime',
        SortDirection.DESC));
    } else if (this.rvtSort.property === 'duration') {
      this.filteredRvtStates = this.filteredRvtStates.sort(this.durationComparator(this.rvtSort.direction));
    } else {
      this.filteredRvtStates = this.filteredRvtStates.sort(this.propertyComparator(this.rvtSort.property,
        this.rvtSort.direction));
    }
    this.rvtPageChanged();
  }

  filterRvtRows(): void {
    if (this.filteredRvtStates) {
      this.filteredRvtStates.splice(0, this.filteredRvtStates.length);
    }

    if (this.rvtStates?.length > 0) {
      this.rvtStates.forEach( configState => {
        this.configurations.forEach( config => {
          if(configState.configurationId === config.id){
            if(config?.manifest?.code) {
              configState.codeResult = config.manifest.code;
            }
          }
        });
      });
      this.filteredRvtStates = [...this.rvtStates]
      .sort(this.propertyComparator('applicationFinishTime',SortDirection.DESC))
      .filter(rvtState => Constants.CONFIGURATION_FINAL_STATES.includes(rvtState.status));
    }
    this.prepareRvtTableData(this.filteredRvtStates);
    this.rvtPageChanged();
  }

  public rvtTabChange(event): void {
    this.selectedRvtTab = event;
    if (event === 1) {
      this.rvtSearchTerm = "";
      this.pageIndex = 0;
      this.paginationSize = 10;
      this.loadRvtStates();
    }
  }

  public executeRvtClick(configuration): void {
    this.executeRvtInProgress = true;
    this.instanceService.executeRVTState(this.instance.id, configuration.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.loadReleaseData();
      },
      (error) => {
        this.executeRvtInProgress = false;
          const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
            this.dialog.open(ErrorDialogComponent, {
              minHeight: '342px',
              width: '630px',
              panelClass: 'flex-dialog',
              data: {
                title: translate('ERROR_DIALOG.RVT_TRANSIENT_FAILED'),
                description: errorMessage
              }
            });
      });
  }

  rvtFilterOptionChange(option): void {
    this.rvtPageIndex = 0;
    this.selectedRvtFilter = option;
    if (option.value) {
      this.rvtStates = this.allRvtStates?.filter(item => option.value.includes(item?.status)) || [];
    } else {
      this.rvtStates = this.allRvtStates || [];
    }
    this.filterRvtRows();
  }

  searchRvt(searchTerm?: string): void {
    this.rvtSearchTerm = searchTerm;
    this.filterRvtRows();
  }

  private rvtPageChanged(event?): void {
    if (event?.length) {
      this.rvtPageIndex = event.pageIndex;
      this.rvtPaginatioSize = event.pageSize;
    }
    const startIndex = this.rvtPageIndex * this.rvtPaginatioSize;
    this.pageRvtStates = this.filteredRvtStates?.slice(startIndex, startIndex + this.rvtPaginatioSize) || [];
  }

  private propertyComparator(property: string, direction: SortDirection): ComparatorFunc {
    return (configurationState1: ConfigurationState, configurationState2: ConfigurationState): number => {
      if (isDate(configurationState1[property])) {
        return direction === SortDirection.ASC
        ? configurationState1[property]?.getTime() - configurationState2[property]?.getTime()
        : configurationState2[property]?.getTime() - configurationState1[property]?.getTime();
      } else {
        if (configurationState1[property] && configurationState2[property]) {
          return direction === SortDirection.ASC
            ? configurationState1[property].localeCompare(configurationState2[property])
            : -(configurationState1[property].localeCompare(configurationState1[property]));
        }
      }
    };
  }

  /**
   * Sorts configuration states for time related column
   * @param - the direction to sort
   */
  private durationComparator(direction: SortDirection): ComparatorFunc {
    return (configurationState1: ConfigurationState, configurationState2: ConfigurationState): number => {
      if (configurationState1.applicationStartTime && configurationState1.applicationFinishTime
        && configurationState2.applicationStartTime && configurationState2.applicationFinishTime) {
          const duration1 = new Date(configurationState1.applicationFinishTime).getTime()
            - new Date(configurationState1.applicationStartTime).getTime();

          const duration2 = new Date(configurationState2.applicationFinishTime).getTime()
            - new Date(configurationState2.applicationStartTime).getTime();

          return direction === SortDirection.ASC ? duration1 - duration2 : duration2 - duration1;
      }
      return 0;
    };
  }

  /**
   * Redirects to view or download function when configuration name is clicked
   * @param - the selected configuration state
   */
  configurationNameClick(configurationState: any, isRvt?: boolean): void {
    this.dialog.open(ConfigurationDetailsComponent, {
      height: '60vh',
      width: '80vw',
      panelClass: 'flex-dialog',
      data: {
        results: true,
        configurationState,
        configuration: this.configurations.find(item => item.id === configurationState.configurationId),
        isRvt
      }
    })
    .afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      if (data) {
        if (data?.type === 'download') {
          this.downloadTestResults(data?.configuration, data?.resultsReportFile);
        } else if (data?.type === 'view') {
          this.viewTestResults(data?.configuration, data?.resultsReportFile, data?.viewType);
        }
      }
    });
  }

  /**
 * Opens the selected result in separate tab for viewing
 * @param - the selected configuration state and file name
 */
  viewTestResults(configurationState: ConfigurationState, filename: string, type?: string): void {
    this.crvtService.getViewResultsUrl(configurationState.blueprintId, configurationState.instanceId, configurationState.id, filename, configurationState.tenantId, type)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((viewUrl) => {
      this.urlService.openUrlInNewTab(viewUrl);
    });
  }

  /**
   * Downloads the selected result
   * @param - the selected configuration state and file name
   */
  downloadTestResults(configurationState: ConfigurationState, filename: string): void {
    const clientName = this.router.url.split('.')[0].split('/')[3];
    const type = 'rvt-results';
    const configuration = this.configurationsMap[configurationState.configurationId];
    this.crvtService.downloadCRVT(configuration.blueprintId, configurationState.instanceId, configurationState.id, filename, clientName, type)
    .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }

  onPageChange(event) {
    this.paginationSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.tableRef?.pageChanged(event);
  }
  onTablePageChanged(event) {
    this.pageIndex = event.pageIndex;
    this.paginationSize = event.pageSize;
  }

  resetPaginator() {
    this.pageIndex = 0;
    this.paginatorRef.pageIndex = 0;
  }
   /**
   * Calls filter function when search term changes for components
   * @param - the search term entered
   */
  searchedItems(result): void {
    this.searchedResult = result;
  }
}
